import type {MouseEvent} from 'react';
/** Pointer convenience only: keyboard and assistive technology retain native record controls. */
export function activateRegisterRecord(event:MouseEvent<HTMLTableRowElement>){
 const target=event.target;
 if(event.defaultPrevented||!(target instanceof Element)||target.closest('a,button,input,select,textarea,summary,label,[contenteditable="true"]')||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||window.getSelection()?.toString())return;
 event.currentTarget.querySelector<HTMLElement>('th[scope="row"] a,th[scope="row"] button')?.click();
}
